import { render, staticRenderFns } from "./contect.vue?vue&type=template&id=faed38b6&scoped=true"
import script from "./contect.vue?vue&type=script&lang=js"
export * from "./contect.vue?vue&type=script&lang=js"
import style0 from "./contect.vue?vue&type=style&index=0&id=faed38b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faed38b6",
  null
  
)

export default component.exports